<template>
  <div class="p-4">
    <ul class="nav nav-tabs nav-tabs-sm mb-4">
      <li
        class="nav-item"
        v-for="figmaPage in figmaPages"
        :key="figmaPage.node"
        @click="setFigmaNode(figmaPage)"
      >
        <a href="#" class="nav-link" :class="{ active: currentFigmaPage.node === figmaPage.node }">
          {{ figmaPage.title }}</a
        >
      </li>
    </ul>
    <div class="iframe-wrapper">
      <iframe
        title="Figma Embed"
        :style="`border: 1px solid rgba(0, 0, 0, 0.1); height: ${windowHeight - 250}px`"
        :src="`https://embed.figma.com/design/Ek6SYyH4u33Ho6Ury92Jej/Atomic-Design-Docs?node-id=${currentFigmaPage.node}&embed-host=share`"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourcesFigma',
  data: () => ({
    windowHeight: window.innerHeight,
    currentFigmaPage: {
      node: '',
      title: '',
    },
    figmaPages: [
      {
        node: '25074-10172',
        title: 'Deposit',
      },
      {
        node: '1532-24156',
        title: 'Verify & Tax',
      },
      {
        node: '35360-29714',
        title: 'Switch',
      },
      {
        node: '16752-30161',
        title: 'Manage',
      },
      {
        node: '29456-54787',
        title: 'CoAuth',
      },
      {
        node: '16086-76023',
        title: 'Errors & Failures',
      },
      {
        node: '32056-19777',
        title: 'Inline',
      },
    ],
  }),
  methods: {
    setFigmaNode: function (figmaPage) {
      this.currentFigmaPage = figmaPage
    },
    onResize() {
      this.windowHeight = window.innerHeight
    },
  },
  mounted() {
    this.currentFigmaPage = this.figmaPages[0]
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped lang="scss">
.iframe-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  /* 16:9 */
  padding-top: 25px;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    @media only screen and (max-width: 1024px) {
      width: 100%;
    }
  }
}
</style>
